module.exports = '<svg width="26" height="32" viewBox="0 0 26 32"><path d="M16.941 1.882h-1.882C15.059 0 14.218 0 13.177 0s-1.882 0-1.882 1.882H9.413c-1.216 0-1.882.875-1.882 1.973v2.824c0 .521.422.851.941.851h9.412c.52 0 .941-.329.941-.851V3.855c0-1.097-.51-1.973-1.882-1.973zm3.765 1.883v4.796c0 .521-.422.851-.941.851H6.589c-.52 0-.941-.329-.941-.851V3.765H1.883c-1.041 0-1.882.934-1.882 1.973v24.471c0 1.041.841 1.792 1.882 1.792h22.588c1.041 0 1.882-.751 1.882-1.792V5.738c0-1.039-.841-1.973-1.882-1.973h-3.765z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/clipboard-1.js
// module id = 1062
// module chunks = 14